import {
  BuildingOffice2Icon,
  CircleStackIcon,
  CogIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/outline"
import { Navigate, NavLink, Outlet } from "react-router-dom"
import { useSelection } from "../app/department-context.tsx"
import { useProfileQuery } from "../features/auth/service.ts"
import { BaseLayout } from "./base-layout.tsx"

export function AdminLayout() {
  const profile = useProfileQuery()
  const { currentOrganization: organization, selectedDepartment, setSelectedDepartment, departments } = useSelection()
  const currentDepartment = departments.find(d => d.id === selectedDepartment?.id)

  if (profile.isLoading) {
    return <div>Загрузка...</div>
  }

  if (!profile.data || profile.data.organization) {
    return <Navigate to="/app/admin" replace />
  }

  return (
    <BaseLayout
      menuItems={isSidebarOpen => (
        <>
          <li>
            <NavLink to="/app/admin/organizations" className={({ isActive }) => (isActive ? "active" : "")}>
              <BuildingOffice2Icon className="w-6 h-6" />
              {isSidebarOpen && <span>Организации</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/admin/departments" className={({ isActive }) => (isActive ? "active" : "")}>
              <UserGroupIcon className="w-6 h-6" />
              {isSidebarOpen && <span>Департаменты</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/admin/data-sources" className={({ isActive }) => (isActive ? "active" : "")}>
              <CircleStackIcon className="w-6 h-6" />
              {isSidebarOpen && <span>Источники данных</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/admin/organization-groups" className={({ isActive }) => (isActive ? "active" : "")}>
              <WrenchScrewdriverIcon className="w-6 h-6" />
              {isSidebarOpen && <span>Конфигурации</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/app/admin/configuration" className={({ isActive }) => (isActive ? "active" : "")}>
              <CogIcon className="w-6 h-6" />
              {isSidebarOpen && <span>Мастер настройки</span>}
            </NavLink>
          </li>
        </>
      )}
      userInfo={
        <>
          <span className="text-sm font-medium">{organization?.title || "Админ"}</span>
          {currentDepartment && (
            <span className="text-xs text-teal-600 dark:text-teal-400">{currentDepartment.title}</span>
          )}
        </>
      }
      bottomMenu={() => (
        <>
          <>
            <li className="menu-title">
              <span>Отделы</span>
            </li>
            {departments.map(dept => (
              <li key={dept.id}>
                <button
                  onClick={() => setSelectedDepartment(dept)}
                  className={selectedDepartment?.id === dept.id ? "active" : ""}
                >
                  {dept.title}
                </button>
              </li>
            ))}
            <li className="border-t border-teal-100 mt-2 pt-2"></li>
          </>
        </>
      )}
    >
      <main className="flex-1 p-4">
        <Outlet />
      </main>
    </BaseLayout>
  )
}
